export default {"src":"/_next/static/media/heart.303a1be4.svg","height":48,"width":48};